import { isHidden } from "@/shared/value";
import {
  CompanyDocumentFileNode,
  CompanyDocumentFolderNode,
  CompanyDocumentTreeNode,
} from "../model/types";

export function isFolderNode(
  node: CompanyDocumentTreeNode,
): node is CompanyDocumentFolderNode {
  return node.__typename === "CompanyDocumentFolderNodeDto";
}

export function isFileNode(
  node: CompanyDocumentTreeNode,
): node is CompanyDocumentFileNode {
  return node.__typename === "CompanyDocumentFileNodeDto";
}

/** Узел закрыт защитой: его идентификатора у клиента нет. */
export function isHiddenNode(node: CompanyDocumentTreeNode): boolean {
  return isHidden(isFolderNode(node) ? node.folder : node.document);
}
